<template>
    <div class="container-fluid">
        <br />
        <el-row :gutter="20">
            <el-col :span="16" :xs="24" class="print-full">
                <el-card class="box-card" id="print">
                    <div slot="header" class="clearfix">
                        <span> Pedidos </span>
                    </div>
                    <el-table
                        ref="multipleTable"
                        :data="orders"
                        :show-summary="true"
                        :summary-method="calculate"
                        style="width: 100%"
                    >
                        <el-table-column
                            property="date"
                            label="Fecha"
                            width="120"
                        />
                        <el-table-column
                            property="clients"
                            label="Cliente"
                            width="240"
                        />
                        <el-table-column
                            property="company"
                            label="Empresa"
                            width="120"
                        />
                        <el-table-column
                            property="subtotal"
                            label="Facturado"
                            type="money"
                            width="120"
                        />

                        <el-table-column
                            property="description"
                            label="Descripcion"
                            width="350"
                        />

                        <el-table-column
                            property="estatus"
                            label="Estado"
                            width="100"
                        />
                    </el-table>

                    <div class="block">
                        <el-pagination
                            v-show="false"
                            @size-change="pageSizeChanged"
                            @current-change="paginate"
                            :current-page.sync="pagination.page"
                            :page-sizes="options.pageList"
                            :page-size="pagination.pageSize"
                            layout="total, prev, pager, next"
                            :total="pagination.total"
                        >
                        </el-pagination>
                    </div>
                </el-card>
            </el-col>

            <el-col :span="8" :xs="24" class="no-print">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span> Filtros </span>
                    </div>
                    <div class="text-right">
                        <el-form
                            ref="form"
                            :model="filters"
                            label-width="120px"
                        >
                            <el-form-item label="Activity name" v-show="false">
                                <el-input v-model="filters.text"></el-input>
                            </el-form-item>
                            <el-form-item label="Fechas">
                                <el-col :span="24">
                                    <el-date-picker
                                        type="date"
                                        placeholder="fecha inicio"
                                        v-model="filters.firstDate"
                                    ></el-date-picker>
                                    <a
                                        href="/pending-orders/add"
                                        class="btn btn-success"
                                    >
                                        Crear orden</a
                                    >
                                    <a
                                        href="/pending-orders/add-csv"
                                        class="btn btn-success"
                                    >
                                        Subir Lista de Pedidos</a
                                    >
                                    <a
                                        v-bind:href="
                                            apiurl +
                                            '/requests/' +
                                            this.$store.state.user.id +
                                            '/' +
                                            dated
                                        "
                                        target="_blank"
                                        class="btn btn-success"
                                    >
                                        Download</a
                                    >
                                </el-col>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-card>
                <br />
            </el-col>
        </el-row>
    </div>
</template>

<script>
import moment from "moment";
import RangeSelector from "../components/RangeSelector";

export default {
    components: {
        RangeSelector,
    },

    data() {
        return {
            name: "OrderList",
            orders: [],
            limit: 400,
            dayTotal: 0,
            apiurl: `${API_URL}`,
            options: {
                pageList: [50, 100, 200],
            },
            q: "",
            dated: null,
            filters: {
                text: "",
                firstDate: moment().toDate(),
                status: false,
                range: false,
            },
            pagination: {
                page: 1,
                pageSize: 50,
            },
        };
    },

    computed: {
        total() {
            const total = this.orders.reduce((total, item) => {
                return (total +=
                    parseFloat(item.subtotal) -
                    parseFloat(item.retention) -
                    parseFloat(item.invoice_payment));
            }, 0);

            return Number(total).toFixed(2);
        },
        invoice_payment() {
            const invoice_payment = this.orders.reduce(
                (invoice_payment, item) => {
                    return (invoice_payment += parseFloat(
                        item.invoice_payment
                    ));
                },
                0
            );

            return Number(invoice_payment).toFixed(2);
        },

        tax() {
            const tax = this.orders.reduce((tax, item) => {
                return (tax += parseFloat(item.tax));
            }, 0);

            return Number(tax).toFixed(2);
        },

        retention() {
            const total = this.orders.reduce((total, item) => {
                return (total += parseFloat(item.retention));
            }, 0);

            return Number(total).toFixed(2);
        },

        subtotal() {
            const total = this.orders.reduce((total, item) => {
                return (total += parseFloat(item.subtotal));
            }, 0);

            return Number(total).toFixed(2);
        },
    },

    async mounted() {
        this.getParams();
        this.getOrders();
        this.dated = moment(this.filters.firstDate).format("YYYY-MM-DD");
    },

    watch: {
        filters: {
            handler() {
                this.getParams();
                this.getOrders();
                this.dated = moment(this.filters.firstDate).format(
                    "YYYY-MM-DD"
                );
            },
            deep: true,
        },
        "$route.path"(path) {
            if (path == "orders") {
                this.getParams();
                this.getOrders();
            }
        },
    },

    methods: {
        printDiv() {
            window.print();
        },
        getParams() {
            let q = `q=(`;
            if (this.filters.firstDate) {
                const firstDate = moment(this.filters.firstDate).format(
                    "YYYY-MM-DD"
                );
                q += `date:${firstDate},`;
            }
            q += `shop_id:${this.$store.state.user.id}`;
            q += `)&`;
            this.q = q;
        },

        getOrders() {
            axios
                .get(`${API_URL}/requests?${this.q}`)
                .then((res) => {
                    this.orders = res.data.map((row) => {
                        return row;
                    });
                })
                .catch((err) => {
                    //this.fallBack()
                });
        },

        getCreditLimit() {
            axios.get(`${API_URL}/employees/${this.employeeId}/limit_credit`);
        },

        getDayTotal() {
            const date = moment().format("YYYY-MM-DD");
            axios
                .get(
                    `${API_URL}/orders/employee-total/${this.employeeId}/${date}`
                )
                .then((res) => {
                    this.dayTotal = res.data.sum;
                });
        },

        pageSizeChanged() {},

        paginate() {},

        calculate(table) {
            const { columns, data } = table;
            const sums = [];

            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = "Totales";
                    return;
                }

                if (index === 1) {
                    sums[index] = "";
                    return;
                }

                const values = data.map((item) =>
                    Number(item[column.property])
                );
                if (!values.every((value) => isNaN(value))) {
                    const sum = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    if (sum) {
                        sums[index] = "RD$ " + parseFloat(sum).toFixed(2);
                    } else {
                        sums[index] = "";
                    }
                } else {
                    sums[index] = "";
                }
            });

            return sums;
        },
    },
};
</script>

<style>
th .el-checkbox {
    display: none;
}
</style>
